import { useEffect, useState } from 'react';
import { approveAdmin, listPendingAdmins, PendingAdmin, rejectAdmin } from '../../api/admin';
import '../StoreManagement/StoreManagementScreen.scss';

function PendingAdminsScreen() {
  const [pendingAdmins, setPendingAdmins] = useState<PendingAdmin[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const rows = await listPendingAdmins();
      setPendingAdmins(rows);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleApprove = async (id: number) => {
    await approveAdmin(id);
    await load();
  };

  const handleReject = async (id: number) => {
    await rejectAdmin(id);
    await load();
  };

  return (
    <div className="StoreManagementScreen">
      <section className="StoreManagementScreen-panel">
        <h2>전체관리자 승인 대기 목록</h2>
        {loading ? (
          <p>불러오는 중...</p>
        ) : pendingAdmins.length === 0 ? (
          <p>승인 대기 중인 가입 신청이 없습니다.</p>
        ) : (
          <table className="StoreManagementScreen-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>이메일</th>
                <th>가입일</th>
                <th>처리</th>
              </tr>
            </thead>
            <tbody>
              {pendingAdmins.map((admin) => (
                <tr key={admin.id}>
                  <td>{admin.id}</td>
                  <td>{admin.email}</td>
                  <td>{new Date(admin.created_at).toLocaleDateString()}</td>
                  <td>
                    <button type="button" onClick={() => handleApprove(admin.id)}>
                      승인
                    </button>
                    {' '}
                    <button type="button" onClick={() => handleReject(admin.id)}>
                      거절
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}

export default PendingAdminsScreen;
